import { PleaseWait } from './pleaseWait';
import { ErrorReporter } from './ErrorReporter';
import { FileSizeValidator } from './fileSizeValidator';
export class FileUploadManager {
    constructor(options) {
        let me = this;
        this.postedFileElement = document.getElementById(options.PostedFileId);
        if (this.postedFileElement) {
            if (options.CustomButtonId) {
                let customButtonElement = document.getElementById(options.CustomButtonId);
                if (customButtonElement) {
                    customButtonElement.addEventListener("click", function () {
                        me.Browse();
                    });
                }
            }
            me.postedFileElement.addEventListener("change", function () {
                let fullPath = me.postedFileElement.value;
                let fileName = fullPath.split(/(\\|\/)/g).pop() ?? '';
                let fileNameElement = document.getElementById(options.FileNameId);
                if (fileNameElement)
                    fileNameElement.innerHTML = fileName;
                let nameElement = document.getElementById(options.NameId);
                if (nameElement) {
                    let fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, "");
                    nameElement.value = fileNameWithoutExt;
                }
                let isValidSize = FileSizeValidator.validateSize(options.PostedFileId, options.MaxSizeInMB);
                if (fileNameElement && options.MaxFileSizeExceededError && !isValidSize)
                    fileNameElement.innerHTML += `<br><span class='text-danger field-validation-error'>${options.MaxFileSizeExceededError}</span>`;
                if (isValidSize && options.AjaxUrl) {
                    let files = me.postedFileElement.files;
                    if (files && files.length > 0) {
                        let fileData = new FormData();
                        for (let i = 0; i < files.length; i++) {
                            fileData.append(files[i].name, files[i]);
                        }
                        if (options.AdditionalAjaxData) {
                            for (var key in options.AdditionalAjaxData) {
                                fileData.append(key, options.AdditionalAjaxData[key]);
                            }
                        }
                        PleaseWait.show();
                        $.ajax({
                            url: options.AjaxUrl,
                            type: "POST",
                            contentType: false,
                            processData: false,
                            data: fileData,
                            error: function (res) {
                                console.log(res);
                                ErrorReporter.ReportAjaxError(options.AjaxUrl, fileData, res);
                                if (fileNameElement)
                                    fileNameElement.innerHTML += `<br><span class='text-danger field-validation-error'><i class='fal fa-square-xmark'></i></span>`;
                                if (options.OnError)
                                    options.OnError(res);
                                PleaseWait.hide();
                            },
                            success: function (result) {
                                if (result.Succeeded === false) {
                                    if (fileNameElement) {
                                        if (result.ErrorMessage)
                                            fileNameElement.innerHTML += `<br><span class='text-danger field-validation-error'>${result.ErrorMessage}</span>`;
                                        else
                                            fileNameElement.innerHTML += `<br><span class='text-danger field-validation-error'><i class='fal fa-square-xmark'></i></span>`;
                                    }
                                    PleaseWait.hide();
                                }
                                else {
                                    if (options.OnSuccess)
                                        options.OnSuccess(result);
                                    if (options.HidePleaseWaitWhenDone)
                                        PleaseWait.hide();
                                }
                            }
                        });
                    }
                }
            }, false);
        }
    }
    Browse() {
        this.postedFileElement.click();
    }
}
window.FileUploadManager = FileUploadManager;
